import React from 'react';
import cn from 'classnames';
import Markup from "../../helpers/Markup";
import styles from './Table.module.scss';
const Table = ({ variation, children, className, tableMarkup = '' }) => {
    return (React.createElement(React.Fragment, null, !tableMarkup ? (React.createElement("table", { className: cn(styles.container, variation && styles[variation], className) }, children)) : (React.createElement(Markup, { Tag: "div", sanitized: false, input: tableMarkup, className: className }))));
};
export default Table;
//# sourceMappingURL=Table.js.map